export default __webpack_public_path__ + "static/media/editImage.ce233c75.jpg";